import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import EnumFlagsDirectiveController from "./EnumFlagDirectiveController";

export default class EnumFlagDirective implements IDirective {
    public bindToController = {
        flagValue: "<mmEnumFlag",
        model: "=mmEnumFlagModel",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = EnumFlagsDirectiveController;
    }
}

module("mmModels").directive("mmEnumFlag", () => new EnumFlagDirective());
